module.exports = __webpack_public_path__ + "static/img/img-vision2.17f2036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-vision2.png
// module id = 8Lgz
// module chunks = 36